/*
[GNU Affero General Public License (AGPL)](https://www.gnu.org/licenses/agpl-3.0.html)

VeloceUI - A UI component library for Angular v17+ made with care by Colibryx Srl in Italy.
Copyright (C) 2025 Colibryx S.r.l.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.

This license applies to any accompanying files located directly in the same directory.
*/

import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { GlobalTemplateModule } from "@app/directives/global-template/global-template.module";
import { DestinationInputComponent } from "@app/widgets/app/destination-input/destination-input.component";
import { TranslateModule } from "@ngx-translate/core";
import { ButtonGroupComponent } from "../button-group/button-group.component";
import { ButtonComponent } from "../button/button.component";
import { CheckboxComponent } from "../checkbox/checkbox/checkbox.component";
import { CodeComponent } from "../code/code.component";
import { DatepickerComponent } from "../datepicker/datepicker.component";
import { FileComponent } from "../file/file.component";
import { InputNumberComponent } from "../input-number/input-number.component";
import { InputPhoneComponent } from "../input-phone/input-phone.component";
import { InputComponent } from "../input/input.component";
import { SelectComponent } from "../select/select.component";
import { TagsInputComponent } from "../tags-input/tags-input.component";
import { TextareaComponent } from "../textarea/textarea.component";
import { TimepickerComponent } from "../timepicker/timepicker.component";
import { ToggleComponent } from "../toggle/toggle.component";
import { FormAlertComponent } from "./form-alert/form-alert.component";
import { FormControlsComponent } from "./form-controls/form-controls.component";
import { FormErrorComponent } from "./form-error/form-error.component";
import { FormGroupComponent } from "./form-group/form-group.component";
import { FormInputComponent } from "./form-input/form-input/form-input.component";
import { FormItemComponent } from "./form-input/form-item/form-item.component";
import { ItemTemplateDirective } from "./form-input/item-template.directive";
import { FormLinkComponent } from "./form-link/form-link.component";
import { FormComponent } from "./form/form.component";
import { GlobalFormControlsHostComponent } from "./global-form-controls-host/global-form-controls-host.component";
import { GlobalFormControlsComponent } from "./global-form-controls/global-form-controls.component";

@NgModule({
	declarations: [
		FormComponent,
		FormControlsComponent,
		FormLinkComponent,
		FormAlertComponent,
		FormErrorComponent,
		FormItemComponent,
		ItemTemplateDirective,
		FormInputComponent,
		GlobalFormControlsComponent,
		GlobalFormControlsHostComponent,
		FormGroupComponent,
	],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		TranslateModule,
		RouterModule,
		GlobalTemplateModule,
		ButtonComponent,
		InputComponent,
		DestinationInputComponent,
		TimepickerComponent,
		ToggleComponent,
		InputNumberComponent,
		TextareaComponent,
		CheckboxComponent,
		CodeComponent,
		InputPhoneComponent,
		SelectComponent,
		DatepickerComponent,
		TagsInputComponent,
		FileComponent,
		ButtonGroupComponent,
	],
	exports: [
		FormComponent,
		FormControlsComponent,
		FormLinkComponent,
		FormAlertComponent,
		FormErrorComponent,
		FormItemComponent,
		GlobalFormControlsComponent,
		GlobalFormControlsHostComponent,
		FormGroupComponent,
	],
	providers: [ReactiveFormsModule],
})
export class FormModule {}
